import { Component, OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'always-active-checkbox-cell',
    templateUrl: './always-active-checkbox-cell.component.html',
    styleUrls: ['./always-active-checkbox-cell.component.scss'],
    standalone: true,
    imports: [FormsModule]
})
export class AlwaysActiveCheckboxCellComponent implements ICellRendererAngularComp {

  private cellName: string = '';

  public data: any;
  public val: boolean = false;
  public originalData: any;
  public api: any;
  public rowIndex: number = -1;
  public columnName: any;
  public isDisabled: boolean = false
  public params: ICellRendererParams;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private elementRef: ElementRef
  ) {
  }

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = params.data;
    this.val = params.value;
    this.api = params.api;
    this.rowIndex = params.node.rowIndex;
    this.cellName = params?.colDef?.cellRenderer?.toString() || '';
    this.columnName = (params.column as any).colId;
    if (this.columnName === 'role-Supervisor') {
      //If disabled value is not null, set it. Otherwise keep default value
      const disabled = params.data.isCheckboxDisabled || params.data.cannotEdit;
      this.isDisabled = !!disabled ? disabled : this.isDisabled;
    }
    if (this.columnName === 'role-DataSubmitter') {
      this.isDisabled = params.data.cannotEdit;
    }

    const agCell = (params.eParentOfValue as HTMLElement)?.closest('.ag-cell') as HTMLElement;
    if (agCell) {
      agCell.addEventListener('focus', () => this.focusIn());
    }
  }

  public refresh(params: any): boolean {
    this.rowIndex = params.rowIndex;
    return false;
  }

  public focusIn(): void {
    const checkbox = this.elementRef.nativeElement.querySelector('input[type="checkbox"]:not([disabled])') as HTMLElement;
    checkbox?.focus();
  }


  public save(): void {
    if (this.api.onActionTrigger) {
      //this.api.onActionTrigger({ row: this.rowIndex, action: "editComplete", data: this.data });
    }
  }
  public valChanged(event:any) {
    if (this.api.onActionTrigger) {
      this.api.onActionTrigger({ row: this.rowIndex, action: "roleUpdate", data: this.data, column: this.columnName, value: this.val });
    }
  }
}
